import { Injectable } from '@angular/core';

import { Payment, Transaction } from '@models';
import { environment } from 'src/environment/environment';
import { CrudService } from '../crud/crud.service';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends CrudService<Payment> {
  constructor(http: HttpService) {
    super('payment', http);
  }

  async getPayments(): Promise<Payment[]> {
    const endpoint = `${environment.apiUrl}/payment/all`;
    const response = await this.http.get<Payment[]>(endpoint);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  async getTransactionById(transactionId: string): Promise<Transaction> {
    const endpoint = `${environment.apiUrl}/payment/transaction/${transactionId}`;
    const response = await this.http.get<Transaction>(endpoint);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  // override methods which are not available for this service
  override create(data: Partial<Payment>): Promise<Payment> {
    throw new Error('Method not available.');
  }
  override get(): Promise<Payment[]> {
    throw new Error('Method not available.');
  }
  override update(data: Partial<Payment>): Promise<Payment> {
    throw new Error('Method not available.');
  }
  override delete(id: string): Promise<string> {
    throw new Error('Method not available.');
  }
}
